import { POI, POI_CATEGORY } from '@/interfaces/poi.interface'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function getPoiWithAddedProperties(poi, poiCategoriesForSelection: POI_CATEGORY[]): POI {
  const poiCopy = { ...poi }
  // poiCopy.properties.categoryId = poiCopy.properties.categories[0].id
  poiCopy.properties.guid = poiCopy.id
  poiCopy.id = poiCopy.id.toMapboxId() // Backend id:s are in a currently unaccepted format.
  poiCopy.properties.id = poiCopy.id
  // poiCopy.properties.categoryName = poiCopy.properties.categories[0].name // Adding directly in properties for styling purposes
  // poiCopy.geometry.coordinates.reverse() // Reversed coordinate order due to wrong order on backend Todo: remove this line when correction is made
  poiCopy.properties.longitude = poiCopy.geometry.coordinates[0]
  poiCopy.properties.latitude = poiCopy.geometry.coordinates[1]
  if (!poiCopy.properties.color) poiCopy.properties.color = '#CCC'
  return poiCopy
}

export function parseJwt(token) {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join('')
  )
  return JSON.parse(jsonPayload)
}
